import React from 'react';
import { observer } from 'mobx-react';
import MessageCenter from './MessageCenterVM';
import { MessageComponent } from './MessageComponent';

export const MessageCenterComponent = observer(() => {
  const message = MessageCenter.currentMessage;
  return (
    <MessageComponent
      message={message}
      clearCallback={() => MessageCenter.clearMessages(true)}
    />
  );
});
